/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  Button,
} from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { dayjs } from '../../../utils/functions';
import { DatePicker } from '../../Datepicker';
import UploadFile from '../CRM/UploadFile';

export function VehicleForm({
  errors,
  vehicle,
  vehicletype,
  Controller,
  control,
  watch,
  setValue,
  FileOpen,
  file,
  setFile,
  setFileOpen,
}) {
  const uploadfile = () => (
    <form>
      <UploadFile
        isOpen={FileOpen}
        files={file}
        setFiles={setFile}
        handleClose={() => setFileOpen(false)}
      />
    </form>
  );
  return (
    <div className="flex flex-row flex-wrap ">
      <div className="w-full px-1 py-2">
        <Controller
          name={'licence_number'}
          control={control}
          defaultValue={vehicle ? vehicle.licence_number : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รหัสเครื่องจักร"
              required
              fullWidth
              size={'small'}
              multiline={true}
              helperText={errors.licence_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full px-1 py-2">
        <Controller
          name={'type'}
          control={control}
          defaultValue={vehicle ? vehicle?.type?._id : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <FormControl sx={{ minWidth: 120 }} fullWidth={true} required>
              <InputLabel id="type" size={'small'}>
                ประเภทเครื่องจักร
              </InputLabel>
              <Select
                {...field}
                label="ประเภทเครื่องจักร"
                size={'small'}
                fullWidth
              >
                {_.size(vehicletype?.rows) ? (
                  _.map(vehicletype.rows, (row) => (
                    <MenuItem key={row._id} value={row._id}>
                      {row.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>
                    <MenuItem disabled value="">
                      <em>ไม่มีข้อมูล</em>
                    </MenuItem>
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          )}
        />
      </div>{' '}
      <div className="w-full px-1 py-2">
        <Controller
          name={'nomachine'}
          control={control}
          defaultValue={vehicle ? vehicle.nomachine : ''}
          render={({ field }) => (
            <TextField
              {...field}
              label="หมายเลขเครื่องจักร(ถ้ามี)"
              fullWidth
              size={'small'}
              multiline={true}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'thainame'}
          control={control}
          defaultValue={vehicle ? vehicle.thainame : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อภาษาไทย(ถ้ามี)"
              fullWidth
              size={'small'}
              multiline={true}
            />
          )}
        />
      </div>
      <div className="w-1/2 px-1 py-2">
        <Controller
          name={'engname'}
          control={control}
          defaultValue={vehicle ? vehicle.engname : ''}
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ชื่อภาษาอังกฤษ(ถ้ามี)"
              fullWidth
              size={'small'}
              multiline={true}
            />
          )}
        />
      </div>
      <div className="w-full py-2 px-1 font-semibold ">
        เกี่ยวกับเครื่องจักร
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.brand'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.brand : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ยี่ห้อ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.brand && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.generation'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.generation : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="วันผลิต(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.generation && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      {/* <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.chassis_number'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.chassis_number : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขคัชชี"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.chassis_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div> */}
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.body_number'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.body_number : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขตัวถัง(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.body_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.buy_year'}
          control={control}
          defaultValue={vehicle?.buy_year}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ปีที่ซื้อ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.buy_year && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'machine.horsepower'}
          control={control}
          defaultValue={vehicle?.machine?.horsepower}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="แรงม้า(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.machine?.horsepower && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'machine.note'}
          control={control}
          defaultValue={vehicle?.machine?.note}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="งานที่ใช้(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.machine?.note && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full py-2 px-1 font-semibold ">เกี่ยวกับมอเตอร์</div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.moter.brand'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.moter?.brand : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ยี่ห้อมอเตอร์(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.moter?.brand && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.moter.model_name'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.moter?.model_name : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รุ่นมอเตอร์(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={
                errors.attribute?.moter?.model_name && 'กรุณาใส่ข้อมูล'
              }
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.moter.capacity'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.moter?.capacity : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ความจุ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.moter?.capacity && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.moter.speed'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.moter?.speed : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ความเร็วรอบ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.moter?.speed && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full py-2 px-1 font-semibold ">เกี่ยวกับเกียร์</div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.gear.brand'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.gear?.brand : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ยี่ห้อเกียร์(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.gear?.brand && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.gear.model_name'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.gear?.model_name : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="รุ่นเกียร์(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={
                errors.attribute?.gear?.model_name && 'กรุณาใส่ข้อมูล'
              }
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.gear.capacity'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.gear?.capacity : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ความจุ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={
                errors.attribute?.motgearer?.capacity && 'กรุณาใส่ข้อมูล'
              }
            />
          )}
        />
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.gear.speed'}
          control={control}
          defaultValue={vehicle ? vehicle?.attribute?.gear?.speed : ''}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="ความเร็วรอบ(ถ้ามี)"
              fullWidth
              size={'small'}
              helperText={errors.attribute?.gear?.speed && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>
      <div>
        <div className="mt-2">{uploadfile()}</div>
      </div>
      <div className="pt-2 pr-8 ">
        <Button
          variant="contained"
          // startIcon={<FileUploadIcon />}
          onClick={() => setFileOpen(true)}
        >
          อัพโหลดเอกสาร
        </Button>
        <div>
          {vehicle?.file && (
            <div className="pl-4">
              <a href={vehicle?.file?.url} target="_blank">
                <h1 className="text-blue-600 font-bold ">
                  {vehicle?.file?.file_name}
                </h1>
              </a>
            </div>
          )}
          {!_.isEmpty(file) && (
            <div className="pl-4">
              <h1 className="font-bold">ไฟล์ใหม่</h1>
              <h1>{file?.[0]?.name}</h1>
            </div>
          )}{' '}
        </div>
      </div>
      {/* <div className="w-full py-2 px-1 font-semibold ">
        เกี่ยวกับ พรบ.รถยนต์
      </div>
      <div className="w-full md:w-1/2 px-1 py-2">
        <Controller
          name={'attribute.invoice_number'}
          control={control}
          defaultValue={vehicle?.attribute?.invoice_number || '-'}
          rules={{ required: false }}
          render={({ field }) => (
            <TextField
              {...field}
              label="เลขที่ พรบ."
              fullWidth
              size={'small'}
              helperText={errors.attribute?.invoice_number && 'กรุณาใส่ข้อมูล'}
            />
          )}
        />
      </div>{' '} */}
      {/* <div className="w-full md:w-1/2 px-1 py-2">
        {!watch('no_invoice_date') && (
          <Controller
            name={'attribute.invoice_date'}
            control={control}
            defaultValue={
              vehicle?.attribute?.invoice_date
                ? dayjs(vehicle?.attribute?.invoice_date).format('YYYY-MM-DD')
                : null
            }
            rules={{ required: false }}
            render={({ field }) => (
              <DatePicker
                {...field}
                setValue={field.onChange}
                label="วันสิ้นสุด พรบ. / วันที่ต้องต่ออายุ"
                value={field?.value}
                onChange={(e) => {
                  field.onChange(e);
                  setValue('attribute.invoice_date', null);
                }}
              />
            )}
          />
        )}
        <Controller
          name="no_invoice_date"
          control={control}
          defaultValue={
            vehicle?.attribute ? !vehicle?.attribute?.invoice_date : false
          }
          render={({ field }) => (
            <FormControlLabel
              label="ไม่ระบุวันสิ้นสุด พรบ. / วันที่ต้องต่ออายุ"
              control={<Checkbox {...field} defaultChecked={field.value} />}
            />
          )}
        />
      </div> */}
    </div>
  );
}

VehicleForm.propTypes = {
  errors: PropTypes.shape({
    licence_number: PropTypes.object,
    type: PropTypes.object,
    attribute: PropTypes.object,
  }),
  vehicle: PropTypes.object,
  vehicletype: PropTypes.object,
  Controller: PropTypes.func,
  control: PropTypes.object,
  watch: PropTypes.func,
  setValue: PropTypes.func,
};

VehicleForm.defaultProps = {
  vehicle: null,
};

export default VehicleForm;
